import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
  inject,
  signal,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription } from 'rxjs';
import { AxiosError } from 'axios';
import { format } from 'date-fns';
import {
  CaseStartCountByLawFirmRow,
  ChartsService,
} from 'src/app/services/charts/charts.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { DecimalPipe, KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-case-starts-by-law-firm-table',
  templateUrl: './case-starts-by-law-firm-table.component.html',
  styleUrls: ['./case-starts-by-law-firm-table.component.scss'],
  imports: [
    MatProgressSpinner,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DecimalPipe,
    KeyValuePipe,
  ],
})
export class CaseStartsByLawFirmTableComponent implements OnDestroy {
  private chartsService = inject(ChartsService);
  private snackbar = inject(MatSnackBar);

  private refreshSub?: Subscription;

  @Input() from_date?: Date;
  @Input() to_date?: Date;

  @Input({ required: true }) set refresh(refresh: Observable<void>) {
    this.refreshSub?.unsubscribe();
    this.refreshSub = refresh.subscribe(async () => await this.setData());
  }

  readonly loading = signal(false);
  @Output() loadingChange = new EventEmitter<boolean>();

  data: CaseStartCountByLawFirmRow[] = [];

  ngOnDestroy(): void {
    this.refreshSub?.unsubscribe();
  }

  async setData(): Promise<void> {
    if (this.loading() || !this.from_date || !this.to_date) {
      return;
    }
    try {
      this.loading.set(true);
      this.loadingChange.emit(true);
      this.data = await this.chartsService.getCaseStartCountsByTransition({
        from_date: format(this.from_date, 'yyyy-MM-dd'),
        to_date: format(this.to_date, 'yyyy-MM-dd'),
      });
    } catch (error: AxiosError | unknown) {
      console.error('Error loading case start counts by law firm', error);
      const message =
        error instanceof AxiosError && error.response?.data?.message
          ? error.response.data.message
          : 'Hiba az ügyindítások (ügyvédi iroda) betöltésekor';
      this.snackbar.open(message, 'OK', { duration: 5000 });
    } finally {
      this.loading.set(false);
      this.loadingChange.emit(false);
    }
  }
}
